module.exports = __webpack_public_path__ + "img/add-user.212c32bb.svg";